// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.site-footer {
  background-size: cover;
  background-position: center;
  color: #fff;
  padding-top: 80px;
}
@media (max-width: 1023px) {
  .site-footer {
    padding-top: 0px;
  }
}
.site-footer a {
  color: #fff;
  text-decoration: none;
  transition: color 0.3s ease;
}
.site-footer a:hover {
  color: #a9c1e8;
}
.site-footer .footer-main {
  padding-bottom: 0px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
}
.site-footer .footer-grid {
  display: grid;
  gap: 40px;
}
@media (max-width: 1023px) {
  .site-footer .footer-grid {
    gap: 30px;
  }
}
@media (max-width: 767px) {
  .site-footer .footer-grid {
    gap: 40px;
  }
}
.site-footer .footer-about {
  padding-bottom: 60px;
}
.site-footer .footer-about .footer-logo {
  margin-bottom: 60px;
  max-width: 320px;
  display: flex;
  align-items: center;
}
@media (max-width: 1023px) {
  .site-footer .footer-about .footer-logo {
    margin-bottom: 28px;
  }
}
.site-footer .footer-about .footer-logo .footer-logo-finans {
  height: 56px;
  width: auto;
  object-fit: contain;
}
.site-footer .footer-about .footer-logo .footer-logo-separator {
  display: inline-block;
  width: 2px;
  height: 42px;
  background-color: #fff;
  margin: 0 20px;
}
.site-footer .footer-about .footer-logo .footer-logo-fintech {
  height: 42px;
  width: auto;
  object-fit: contain;
  opacity: 1;
}
.site-footer .footer-about .footer-description {
  font-size: 14px !important;
  line-height: 1.6;
  color: #fff;
  margin-bottom: 20px;
  font-weight: 300;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
}
.site-footer .footer-about .footer-description:last-child {
  margin-bottom: 0;
}
.site-footer .footer-about .footer-description img {
  width: 28px;
  height: 28px;
}
.site-footer .footer-about .footer-description a {
  color: #fff;
  text-decoration: none;
  transition: color 0.3s ease;
}
.site-footer .footer-about .footer-description a:hover {
  color: #09B175;
}
.site-footer .footer-about .footer-social {
  display: flex;
  gap: 25px;
  margin-top: 50px;
}
.site-footer .footer-about .footer-social a img {
  width: 20px;
  height: 20px;
  transition: opacity 0.3s ease;
}
.site-footer .footer-about .footer-social a:hover img {
  opacity: 1;
}
@media (max-width: 767px) {
  .site-footer .footer-about {
    order: 3;
    padding-top: 25px;
  }
}
.site-footer .footer-links h3.footer-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 40px;
}
@media (max-width: 767px) {
  .site-footer .footer-links h3.footer-title {
    margin-bottom: 5px;
  }
}
.site-footer .footer-links ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.site-footer .footer-links ul li {
  margin-bottom: 25px;
}
.site-footer .footer-links ul li a {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 400;
}
.site-footer .footer-links ul li a img {
  margin-right: 16px;
  width: 16px;
  height: 16px;
}
@media (max-width: 767px) {
  .site-footer .footer-links {
    order: 2;
  }
  .site-footer .footer-links h3.footer-title {
    cursor: pointer;
    position: relative;
    padding-right: 20px;
    transition: color 0.3s ease;
  }
  .site-footer .footer-links h3.footer-title::after {
    content: "+";
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    font-size: 24px;
    transition: transform 0.3s ease;
  }
  .site-footer .footer-links ul {
    max-height: 0;
    overflow: hidden;
    opacity: 0;
    padding-top: 0;
    transition: max-height 0.4s ease-out, opacity 0.3s ease-in, padding-top 0.4s ease-out;
    margin-top: 0;
    margin-bottom: 0;
  }
  .site-footer .footer-links.active ul {
    max-height: 500px;
    opacity: 1;
    padding-top: 15px;
    margin-top: 10px;
  }
  .site-footer .footer-links.active h3.footer-title::after {
    content: "-";
    transform: translateY(-50%) rotate(180deg);
  }
}
.site-footer .footer-subscribe h3.footer-title {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 40px;
}
@media (max-width: 767px) {
  .site-footer .footer-subscribe h3.footer-title {
    margin-bottom: 25px;
  }
}
.site-footer .footer-subscribe p {
  font-size: 16px;
  line-height: 1.6;
  color: #fff;
  margin-bottom: 25px;
}
.site-footer .footer-subscribe .newsletter-form {
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 20px;
}
@media (min-width: 768px) and (max-width: 1023px) {
  .site-footer .footer-subscribe .newsletter-form {
    width: 500px;
  }
}
.site-footer .footer-subscribe .newsletter-form input[type=email] {
  flex-grow: 1;
  background-color: #000000;
  border: none;
  border-radius: 50px;
  padding: 15px 70px 15px 25px;
  color: #fff;
  font-size: 16px;
  height: 55px;
  box-sizing: border-box;
}
.site-footer .footer-subscribe .newsletter-form input[type=email]::placeholder {
  color: rgba(255, 255, 255, 0.6);
}
.site-footer .footer-subscribe .newsletter-form button[type=submit] {
  position: absolute;
  right: -2px;
  top: 50%;
  transform: translateY(-50%);
  width: 60px;
  height: 60px;
  background-color: #09B175;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  transition: background-color 0.3s ease;
  z-index: 1;
}
.site-footer .footer-subscribe .newsletter-form button[type=submit]:hover {
  background-color: #0ad286;
}
.site-footer .footer-subscribe .newsletter-form button[type=submit] img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}
.site-footer .footer-subscribe .privacy-check {
  display: flex;
  align-items: flex-start;
}
.site-footer .footer-subscribe .privacy-check input[type=radio] {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid #09B175;
  background-color: transparent;
  margin-right: 10px;
  margin-top: 3px;
  cursor: pointer;
  position: relative;
  flex-shrink: 0;
  transition: border-color 0.2s ease;
}
.site-footer .footer-subscribe .privacy-check input[type=radio]:checked {
  background-color: transparent;
  border-color: #09B175;
}
.site-footer .footer-subscribe .privacy-check input[type=radio]:checked::after {
  content: "";
  display: block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #09B175;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: background-color 0.2s ease;
}
.site-footer .footer-subscribe .privacy-check label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.72);
  line-height: 1.5;
  cursor: pointer;
}
.site-footer .footer-subscribe .privacy-check label span {
  color: #fff;
  transition: color 0.3s ease;
}
.site-footer .footer-subscribe .privacy-check label span:hover {
  color: #09B175;
}
@media (max-width: 767px) {
  .site-footer .footer-subscribe {
    order: 1;
  }
}
.site-footer .footer-bottom {
  padding: 25px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.15);
}
.site-footer .footer-bottom .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
}
.site-footer .footer-bottom .copyright {
  font-size: 14px;
  font-weight: 300;
  color: #fff;
  margin: 0;
  flex-grow: 1;
  text-align: left;
}
@media (max-width: 767px) {
  .site-footer .footer-bottom .copyright {
    width: 100%;
    text-align: left;
    margin-bottom: 40px;
    font-size: 16px;
    font-weight: 400;
  }
}
.site-footer .footer-bottom .footer-bottom-links {
  display: flex;
  gap: 25px;
  flex-shrink: 0;
}
.site-footer .footer-bottom .footer-bottom-links a, .site-footer .footer-bottom .footer-bottom-links .aydinlatma-link-button {
  font-size: 14px;
  color: #fff;
  font-weight: 300;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.3s ease;
}
.site-footer .footer-bottom .footer-bottom-links a:hover, .site-footer .footer-bottom .footer-bottom-links .aydinlatma-link-button:hover {
  color: #09B175;
}
@media (max-width: 767px) {
  .site-footer .footer-bottom .footer-bottom-links a, .site-footer .footer-bottom .footer-bottom-links .aydinlatma-link-button {
    font-size: 16px;
    font-weight: 400;
  }
}
.site-footer .footer-bottom .footer-bottom-links .aydinlatma-link-button {
  font-family: inherit;
}
@media (max-width: 767px) {
  .site-footer .footer-bottom .footer-bottom-links {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    gap: 20px;
  }
}
@media (max-width: 767px) {
  .site-footer .footer-bottom .container {
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
  }
}
@media (max-width: 1023px) {
  .site-footer .footer-main {
    padding-bottom: 0;
  }
  .site-footer .footer-main .footer-grid {
    display: flex;
    flex-direction: column;
    gap: 0;
  }
  .site-footer .footer-main .footer-column {
    width: 100%;
    padding: 0;
    text-align: left;
  }
  .site-footer .footer-main .footer-subscribe {
    order: 1;
    padding-bottom: 48px;
  }
  .site-footer .footer-main .footer-servis {
    order: 2;
    padding-top: 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  }
  .site-footer .footer-main .footer-link {
    order: 3;
    padding-top: 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  }
  .site-footer .footer-main .footer-about {
    order: 4;
    padding-top: 72px;
    padding-bottom: 72px;
  }
  .site-footer .footer-main .footer-links {
    order: 2;
  }
  .site-footer .footer-main .footer-links .footer-title {
    font-size: 16px;
    font-weight: 500;
    position: relative;
    cursor: pointer;
    padding: 20px 40px 20px 0;
    margin: 0;
  }
  .site-footer .footer-main .footer-links .footer-title::after {
    content: "+";
    font-size: 24px;
    font-weight: 300;
    color: #fff;
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
    transition: transform 0.3s ease;
  }
  .site-footer .footer-main .footer-links ul {
    max-height: 0;
    overflow: hidden;
    visibility: hidden;
    opacity: 0;
    margin: 0;
    padding: 0 0 0 15px;
    list-style: none;
    text-align: left;
    transition: max-height 0.4s ease-out, opacity 0.3s ease-in, padding-top 0.4s ease-out, padding-bottom 0.4s ease-out, visibility 0s linear 0.4s;
  }
  .site-footer .footer-main .footer-links ul li {
    padding: 8px 0;
  }
  .site-footer .footer-main .footer-links ul li a {
    font-size: 14px;
    display: flex;
    align-items: center;
  }
  .site-footer .footer-main .footer-links ul li a img {
    margin-right: 8px;
    width: 12px;
  }
  .site-footer .footer-main .footer-links.active .footer-title::after {
    content: "-";
    transform: translateY(-50%);
  }
  .site-footer .footer-main .footer-links.active ul {
    max-height: 300px;
    visibility: visible;
    opacity: 1;
    padding-top: 10px;
    padding-bottom: 20px;
    transition: max-height 0.4s ease-out, opacity 0.3s ease-in 0.1s, padding-top 0.4s ease-out, padding-bottom 0.4s ease-out, visibility 0s linear 0s;
  }
  .site-footer .footer-main .footer-about {
    text-align: center;
  }
  .site-footer .footer-main .footer-about .footer-description {
    text-align: left;
  }
  .site-footer .footer-bottom {
    padding: 72px 0 72px 0;
  }
}

.modal {
  display: none;
  position: fixed;
  z-index: 1001;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  opacity: 0;
  transition: opacity 0.3s ease;
}
.modal[style*=block] {
  display: flex !important;
  align-items: center;
  justify-content: center;
  opacity: 1;
}
@media (max-width: 767px) {
  .modal {
    padding-top: 0;
  }
}

.modal-content {
  background-color: #fefefe;
  padding: 30px;
  border: 1px solid #888;
  width: 90%;
  max-width: 800px;
  border-radius: 8px;
  position: relative;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  max-height: 80vh;
  overflow-y: auto;
  transform: translateY(-50px);
  transition: transform 0.3s ease;
}
.modal[style*=block] .modal-content {
  transform: translateY(0);
}
@media (max-width: 767px) {
  .modal-content {
    width: 100%;
    height: 100%;
    max-width: none;
    margin: 0;
    border-radius: 0;
    border: none;
    box-shadow: none;
    display: flex;
    flex-direction: column;
    padding: 20px 20px 0 20px;
    max-height: none;
  }
}
.modal-content h2 {
  margin-top: 0;
  color: #333;
  border-bottom: 1px solid #eee;
  padding-bottom: 15px;
  margin-bottom: 20px;
}
@media (max-width: 767px) {
  .modal-content h2 {
    padding-right: 45px;
    flex-shrink: 0;
  }
}
.modal-content .modal-text-content {
  overflow-y: auto;
  color: #555;
  line-height: 1.6;
}
@media (max-width: 767px) {
  .modal-content .modal-text-content {
    flex-grow: 1;
  }
}
.modal-content .modal-text-content p {
  margin-bottom: 15px;
}
.modal-content .modal-text-content ul {
  margin-bottom: 15px;
  padding-left: 20px;
  list-style-type: disc;
}
.modal-content .modal-text-content .modal-hukuki-sebep {
  margin-top: 12px;
}

.modal-close-button {
  color: #aaa;
  font-size: 28px;
  font-weight: bold;
  position: absolute;
  top: 15px;
  right: 25px;
  cursor: pointer;
}
.modal-close-button:hover, .modal-close-button:focus {
  color: black;
  text-decoration: none;
}
@media (max-width: 767px) {
  .modal-close-button {
    top: 12px;
    right: 15px;
    font-size: 26px;
  }
}

@keyframes animatetop {
  from {
    top: -300px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}
.modal-table {
  display: flex;
  flex-direction: column;
  gap: 1px;
  background-color: #ddd;
  border: 1px solid #ddd;
  margin-bottom: 20px;
}

.modal-table-header,
.modal-table-row {
  display: flex;
  background-color: #f9f9f9;
}

.modal-table-header {
  background-color: #f0f0f0;
  font-weight: bold;
}

.modal-table-cell {
  padding: 10px 12px;
  flex-grow: 1;
  flex-basis: 0;
  border-left: 1px solid #ddd;
}
.modal-table-cell:first-child {
  border-left: none;
}
.modal-table-cell p, .modal-table-cell ul {
  margin: 0;
  font-size: 13px;
}
.modal-table-cell ul {
  padding-left: 18px;
  list-style-type: disc;
}

.header-kategori, .cell-kategori {
  flex-grow: 0.8;
}

.header-amac, .cell-amac {
  flex-grow: 1.5;
}

.header-sebep, .cell-sebep {
  flex-grow: 1;
}

.header-aktarilan, .cell-aktarilan {
  flex-grow: 1.2;
}

.header-aktarim-amac, .cell-aktarim-amac {
  flex-grow: 1;
}

.header-aktarim-sebep, .cell-aktarim-sebep {
  flex-grow: 1.2;
}

@media (max-width: 767px) {
  .modal-table {
    overflow-x: auto;
    display: block;
  }
  .modal-table-header {
    display: flex;
    min-width: 700px;
  }
  .modal-table-row {
    min-width: 700px;
    display: flex;
  }
  .modal-table-cell {
    white-space: normal;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/footer/Footer.scss"],"names":[],"mappings":"AACA;EACI,sBAAA;EACA,2BAAA;EACA,WAAA;EACA,iBAAA;AAAJ;AAEI;EANJ;IAOQ,gBAAA;EACN;AACF;AACI;EACI,WAAA;EACA,qBAAA;EACA,2BAAA;AACR;AACQ;EACI,cAAA;AACZ;AAGI;EACI,mBAAA;EACA,kDAAA;AADR;AAII;EACI,aAAA;EAEA,SAAA;AAHR;AAKQ;EALJ;IAOQ,SAAA;EAHV;AACF;AAKQ;EAVJ;IAYQ,SAAA;EAHV;AACF;AAWI;EACI,oBAAA;AATR;AAUQ;EACI,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AARZ;AAUY;EANJ;IAOQ,mBAAA;EAPd;AACF;AASY;EACI,YAAA;EACA,WAAA;EACA,mBAAA;AAPhB;AAUY;EACI,qBAAA;EACA,UAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;AARhB;AAWY;EACI,YAAA;EACA,WAAA;EACA,mBAAA;EACA,UAAA;AAThB;AAaQ;EACI,0BAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AAXZ;AAaY;EACI,gBAAA;AAXhB;AAcY;EACI,WAAA;EACA,YAAA;AAZhB;AAeY;EACI,WAAA;EACA,qBAAA;EACA,2BAAA;AAbhB;AAegB;EACI,cAAA;AAbpB;AAkBQ;EACI,aAAA;EACA,SAAA;EACA,gBAAA;AAhBZ;AAmBgB;EACI,WAAA;EACA,YAAA;EACA,6BAAA;AAjBpB;AAmBgB;EACI,UAAA;AAjBpB;AAsBQ;EAlFJ;IAmFQ,QAAA;IACA,iBAAA;EAnBV;AACF;AAwBQ;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AAtBZ;AAwBY;EALJ;IAMQ,kBAAA;EArBd;AACF;AAwBQ;EACI,gBAAA;EACA,UAAA;EACA,SAAA;AAtBZ;AAwBY;EACI,mBAAA;AAtBhB;AAwBgB;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAtBpB;AAwBoB;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AAtBxB;AA6BQ;EAnCJ;IAoCQ,QAAA;EA1BV;EA4BW;IACG,eAAA;IACA,kBAAA;IACA,mBAAA;IACA,2BAAA;EA1Bd;EA4Bc;IACI,YAAA;IACA,kBAAA;IACA,QAAA;IACA,QAAA;IACA,2BAAA;IACA,eAAA;IACA,+BAAA;EA1BlB;EA8BW;IAEG,aAAA;IACA,gBAAA;IACA,UAAA;IACA,cAAA;IACA,qFAAA;IACA,aAAA;IACA,gBAAA;EA7Bd;EAiCc;IAEI,iBAAA;IACA,UAAA;IACA,iBAAA;IACA,gBAAA;EAhClB;EAkCc;IACI,YAAA;IACA,0CAAA;EAhClB;AACF;AAuCQ;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AArCZ;AAuCY;EALJ;IAMQ,mBAAA;EApCd;AACF;AAuCQ;EACI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;AArCZ;AAwCQ;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAtCZ;AAyCY;EAPJ;IAQQ,YAAA;EAtCd;AACF;AAwCY;EACI,YAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,4BAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;AAtChB;AAwCgB;EACI,+BAAA;AAtCpB;AA0CY;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,UAAA;EACA,sCAAA;EACA,UAAA;AAxChB;AA0CgB;EACI,yBAAA;AAxCpB;AA2CgB;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AAzCpB;AA8CQ;EACI,aAAA;EACA,uBAAA;AA5CZ;AA8CY;EACI,gBAAA;EACA,wBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EAsBC,kCAAA;AAjEjB;AA6CgB;EACI,6BAAA;EACA,qBAAA;AA3CpB;AA6CoB;EACI,WAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EAEA,sCAAA;AA5CxB;AAmDY;EACI,eAAA;EACA,gCAAA;EAEA,gBAAA;EACA,eAAA;AAlDhB;AAoDgB;EACI,WAAA;EACA,2BAAA;AAlDpB;AAoDoB;EACG,cAAA;AAlDvB;AAwDQ;EAvIJ;IAwIQ,QAAA;EArDV;AACF;AAyDI;EACI,eAAA;EACA,+CAAA;AAvDR;AAyDQ;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AAvDZ;AA0DQ;EACI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;AAxDZ;AAyDa;EAPL;IAQQ,WAAA;IACA,gBAAA;IACA,mBAAA;IACA,eAAA;IACA,gBAAA;EAtDd;AACF;AAyDQ;EACI,aAAA;EACA,SAAA;EACA,cAAA;AAvDZ;AAyDY;EACI,eAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,qBAAA;EACA,2BAAA;AAvDhB;AAyDgB;EACG,cAAA;AAvDnB;AA0DgB;EAfJ;IAgBQ,eAAA;IACA,gBAAA;EAvDlB;AACF;AA0DY;EACI,oBAAA;AAxDhB;AA2Da;EA9BL;IA+BQ,sBAAA;IACA,uBAAA;IACA,WAAA;IACA,SAAA;EAxDd;AACF;AA2DS;EACG;IACI,sBAAA;IACA,uBAAA;IACA,gBAAA;EAzDd;AACF;AAuEI;EACI;IACI,iBAAA;EArEV;EAuEU;IACI,aAAA;IACA,sBAAA;IACA,MAAA;EArEd;EAwEU;IACI,WAAA;IACA,UAAA;IACA,gBAAA;EAtEd;EA0EU;IAAoB,QAAA;IAAU,oBAAA;EAtExC;EAuEU;IACI,QAAA;IACA,iBAAA;IACA,kDAAA;EArEd;EAuEU;IACI,QAAA;IACA,iBAAA;IACA,kDAAA;EArEd;EAuEU;IACI,QAAA;IACD,iBAAA;IACC,oBAAA;EArEd;EA2EU;IACI,QAAA;EAzEd;EA2Ec;IACI,eAAA;IACA,gBAAA;IACA,kBAAA;IACA,eAAA;IACA,yBAAA;IACA,SAAA;EAzElB;EA2EkB;IACI,YAAA;IACA,eAAA;IACA,gBAAA;IACA,WAAA;IACA,kBAAA;IACA,UAAA;IACA,QAAA;IACA,2BAAA;IACA,+BAAA;EAzEtB;EA6Ec;IAEI,aAAA;IACA,gBAAA;IACA,kBAAA;IACA,UAAA;IACA,SAAA;IACA,mBAAA;IACA,gBAAA;IACA,gBAAA;IACA,8IAAA;EA5ElB;EA8EkB;IACI,cAAA;EA5EtB;EA6EsB;IACG,eAAA;IACA,aAAA;IACA,mBAAA;EA3EzB;EA4EyB;IACI,iBAAA;IACA,WAAA;EA1E7B;EAmFkB;IACI,YAAA;IACA,2BAAA;EAjFtB;EAmFkB;IACI,iBAAA;IACA,mBAAA;IACA,UAAA;IACA,iBAAA;IACA,oBAAA;IAEA,iJAAA;EAlFtB;EA4FU;IAGK,kBAAA;EA5Ff;EA8Fc;IACK,gBAAA;EA5FnB;EAkGM;IACK,sBAAA;EAhGX;AACF;;AAsGA;EACI,aAAA;EACA,eAAA;EACA,aAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,UAAA;EACA,6BAAA;AAnGJ;AAsGI;EACI,wBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AApGR;AAuGI;EApBJ;IAqBQ,cAAA;EApGN;AACF;;AAuGA;EACI,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,0CAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;EACA,+BAAA;AApGJ;AAsGI;EACI,wBAAA;AApGR;AAuGI;EAlBJ;IAmBQ,WAAA;IACA,YAAA;IACA,eAAA;IACA,SAAA;IACA,gBAAA;IACA,YAAA;IACA,gBAAA;IACA,aAAA;IACA,sBAAA;IACA,yBAAA;IACA,gBAAA;EApGN;AACF;AAuGI;EACI,aAAA;EACA,WAAA;EACA,6BAAA;EACA,oBAAA;EACA,mBAAA;AArGR;AAuGQ;EAPJ;IAQQ,mBAAA;IACA,cAAA;EApGV;AACF;AAyGI;EAEI,gBAAA;EAEA,WAAA;EACA,gBAAA;AAzGR;AA2GQ;EAPJ;IAQQ,YAAA;EAxGV;AACF;AA6GQ;EACI,mBAAA;AA3GZ;AA8GQ;EACI,mBAAA;EACA,kBAAA;EACA,qBAAA;AA5GZ;AA+GQ;EACI,gBAAA;AA7GZ;;AAkHA;EACI,WAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;AA/GJ;AAiHI;EAEI,YAAA;EACA,qBAAA;AAhHR;AAmHI;EAfJ;IAgBQ,SAAA;IACA,WAAA;IACA,eAAA;EAhHN;AACF;;AAoHA;EACI;IAAM,WAAA;IAAa,UAAA;EA/GrB;EAgHE;IAAI,MAAA;IAAQ,UAAA;EA5Gd;AACF;AA+GA;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;AA7GJ;;AAgHA;;EAEI,aAAA;EACA,yBAAA;AA7GJ;;AAgHA;EACI,yBAAA;EACA,iBAAA;AA7GJ;;AAgHA;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,2BAAA;AA7GJ;AA+GI;EACI,iBAAA;AA7GR;AAgHI;EACI,SAAA;EACA,eAAA;AA9GR;AAiHI;EACI,kBAAA;EACA,qBAAA;AA/GR;;AAoHA;EACI,cAAA;AAjHJ;;AAmHA;EACI,cAAA;AAhHJ;;AAkHA;EACI,YAAA;AA/GJ;;AAmHA;EACI,cAAA;AAhHJ;;AAkHA;EACI,YAAA;AA/GJ;;AAiHA;EACI,cAAA;AA9GJ;;AAkHA;EACI;IACI,gBAAA;IACA,cAAA;EA/GN;EAkHE;IACI,aAAA;IACA,gBAAA;EAhHN;EAmHE;IACI,gBAAA;IACA,aAAA;EAjHN;EAoHE;IACI,mBAAA;EAlHN;AACF","sourcesContent":["// Footer Section\n.site-footer {\n    background-size: cover;\n    background-position: center;\n    color: #fff;\n    padding-top: 80px; // Üst boşluk\n\n    @media (max-width: 1023px) {\n        padding-top: 0px \n    }\n\n    a {\n        color: #fff;\n        text-decoration: none;\n        transition: color 0.3s ease;\n\n        &:hover {\n            color: #a9c1e8; // Hover rengi\n        }\n    }\n\n    .footer-main {\n        padding-bottom: 0px;\n        border-bottom: 1px solid rgba(255, 255, 255, 0.15); // Alt çizgi\n    }\n\n    .footer-grid {\n        display: grid;\n       // grid-template-columns: repeat(4, 1fr); // 4 sütunlu grid\n        gap: 40px;\n\n        @media (max-width: 1023px) {\n            //grid-template-columns: repeat(2, 1fr); // Tablette 2 sütun\n            gap: 30px;\n        }\n\n        @media (max-width: 767px) {\n            //grid-template-columns: 1fr; // Mobilde tek sütun\n            gap: 40px; // Mobil sütunlar arası boşluk\n        }\n    }\n\n    //.footer-column {\n        // Genel sütun stilleri\n    //}\n\n    // Column 1: About\n    .footer-about {\n        padding-bottom: 60px;\n        .footer-logo {\n            margin-bottom: 60px;\n            max-width: 320px; \n            display: flex;\n            align-items: center;\n\n            @media (max-width: 1023px) {\n                margin-bottom: 28px;\n            }\n\n            .footer-logo-finans {\n                height: 56px; \n                width: auto; \n                object-fit: contain;\n            }\n\n            .footer-logo-separator {\n                display: inline-block;\n                width: 2px;\n                height: 42px; \n                background-color: #fff; \n                margin: 0 20px; \n            }\n\n            .footer-logo-fintech {\n                height: 42px; \n                width: auto; \n                object-fit: contain;\n                opacity: 1; \n            }\n        }\n\n        .footer-description {\n            font-size: 14px !important;\n            line-height: 1.6;\n            color: #fff; // Daha açık renk\n            margin-bottom: 20px;\n            font-weight: 300;\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            gap: 10px;\n\n            &:last-child {\n                margin-bottom: 0;\n            }\n\n            img {\n                width: 28px;\n                height: 28px;\n            }\n\n            a {\n                color: #fff;\n                text-decoration: none;\n                transition: color 0.3s ease;\n\n                &:hover {\n                    color: #09B175;\n                }\n            }\n        }\n\n        .footer-social {\n            display: flex;\n            gap: 25px;\n            margin-top: 50px;\n\n            a {\n                img {\n                    width: 20px;\n                    height: 20px;\n                    transition: opacity 0.3s ease;\n                }\n                &:hover img {\n                    opacity: 1;\n                }\n            }\n        }\n\n        @media (max-width: 767px) {\n            order: 3; // Mobilde en alta\n            padding-top: 25px;\n        }\n    }\n\n    // Column 2 & 3: Links\n    .footer-links {\n        h3.footer-title {\n            font-size: 20px;\n            font-weight: 600;\n            margin-bottom: 40px;\n\n            @media (max-width: 767px) {\n                margin-bottom: 5px;\n            }\n        }\n\n        ul {\n            list-style: none;\n            padding: 0;\n            margin: 0;\n\n            li {\n                margin-bottom: 25px;\n\n                a {\n                    display: flex;\n                    align-items: center;\n                    font-size: 16px;\n                    font-weight: 400;\n\n                    img { // Link ikonları\n                        margin-right: 16px;\n                        width: 16px;\n                        height: 16px;\n                    }\n                }\n            }\n        }\n\n        // Mobil için Accordion Hazırlığı (JS eklenecek)\n        @media (max-width: 767px) {\n            order: 2; // Mobilde ortaya\n\n             h3.footer-title {\n                cursor: pointer; // Tıklanabilir olduğunu belirt\n                position: relative;\n                padding-right: 20px; // Ok için yer\n                transition: color 0.3s ease; // Başlık rengi için de geçiş (opsiyonel)\n\n                &::after { // Accordion oku\n                    content: '+'; // Veya bir ikon\n                    position: absolute;\n                    right: 0;\n                    top: 50%;\n                    transform: translateY(-50%);\n                    font-size: 24px;\n                    transition: transform 0.3s ease; // İkon dönüşümü için\n                }\n             }\n\n             ul {\n                // display: none; // Display yerine max-height kullanacağız\n                max-height: 0; // Başlangıçta yükseklik 0\n                overflow: hidden; // Taşan içeriği gizle\n                opacity: 0; // Başlangıçta şeffaf\n                padding-top: 0; // Başlangıçta üst padding olmasın\n                transition: max-height 0.4s ease-out, opacity 0.3s ease-in, padding-top 0.4s ease-out; // Geçiş efektleri\n                margin-top: 0; // Ekstra boşlukları sıfırla\n                margin-bottom: 0; // Ekstra boşlukları sıfırla\n             }\n\n             &.active { // JS ile eklenecek class\n                ul {\n                    // display: block; // Artık gerekli değil\n                    max-height: 500px; // İçeriğin sığacağı kadar büyük bir değer (gerekirse artır)\n                    opacity: 1; // Görünür yap\n                    padding-top: 15px; // İçerik açıldığında padding gelsin\n                    margin-top: 10px; // Başlıkla liste arasına boşluk\n                }\n                h3.footer-title::after {\n                    content: '-';\n                    transform: translateY(-50%) rotate(180deg); // İkonu döndür (opsiyonel)\n                }\n             }\n        }\n    }\n\n    // Column 4: Subscribe\n    .footer-subscribe {\n        h3.footer-title {\n            font-size: 22px;\n            font-weight: 600;\n            margin-bottom: 40px;\n\n            @media (max-width: 767px) {\n                margin-bottom: 25px;\n            }\n        }\n\n        p {\n            font-size: 16px;\n            line-height: 1.6;\n            color: #fff;\n            margin-bottom: 25px;\n        }\n\n        .newsletter-form {\n            display: flex;\n            align-items: center;\n            position: relative;\n            margin-bottom: 20px;\n\n\n            @media (min-width: 768px) and (max-width: 1023px) {\n                width: 500px;\n            }\n\n            input[type=\"email\"] {\n                flex-grow: 1;\n                background-color: #000000;\n                border: none;\n                border-radius: 50px;\n                padding: 15px 70px 15px 25px;\n                color: #fff;\n                font-size: 16px;\n                height: 55px;\n                box-sizing: border-box;\n\n                &::placeholder {\n                    color: rgba(255, 255, 255, 0.6);\n                }\n            }\n\n            button[type=\"submit\"] {\n                position: absolute;\n                right: -2px;\n                top: 50%;\n                transform: translateY(-50%);\n                width: 60px;\n                height: 60px;\n                background-color: #09B175;\n                border: none;\n                border-radius: 50%;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                cursor: pointer;\n                padding: 0;\n                transition: background-color 0.3s ease;\n                z-index: 1;\n\n                &:hover {\n                    background-color: #0ad286;\n                }\n\n                img {\n                    width: 24px;\n                    height: 24px;\n                    object-fit: contain;\n                }\n            }\n        }\n\n        .privacy-check {\n            display: flex;\n            align-items: flex-start;\n\n            input[type=\"radio\"] {\n                appearance: none;\n                -webkit-appearance: none;\n                -moz-appearance: none;\n                width: 16px; // Genişlik\n                height: 16px; // Yükseklik\n                border-radius: 50%;\n                border: 1px solid #09B175;\n                background-color: transparent;\n                margin-right: 10px;\n                margin-top: 3px; // Dikey hizalamayı hafif ayarla (fonta göre değişebilir)\n                cursor: pointer;\n                position: relative;\n                flex-shrink: 0; // Küçülmesini engelle\n\n                &:checked {\n                    background-color: transparent;\n                    border-color: #09B175;\n\n                    &::after {\n                        content: '';\n                        display: block;\n                        width: 6px; // İç noktayı küçültelim (16px'in yarısından küçük)\n                        height: 6px; // İç noktayı küçültelim\n                        border-radius: 50%;\n                        background-color: #09B175;\n                        position: absolute;\n                        top: 50%;\n                        left: 50%;\n                        transform: translate(-50%, -50%);\n                        // Daha yumuşak görünüm için transition eklenebilir\n                        transition: background-color 0.2s ease;\n                    }\n                }\n                 // Seçildiğinde daha hızlı tepki vermesi için\n                 transition: border-color 0.2s ease;\n            }\n\n            label {\n                font-size: 14px;\n                color: rgba(255, 255, 255, 0.72);\n                \n                line-height: 1.5;\n                cursor: pointer;\n\n                span {\n                    color: #fff;\n                    transition: color 0.3s ease;\n\n                    &:hover {\n                       color: #09B175;\n                    }\n                }\n            }\n        }\n\n        @media (max-width: 767px) {\n            order: 1; // Mobilde en üste\n        }\n    }\n\n    // Footer Bottom Bar\n    .footer-bottom {\n        padding: 25px 0;\n        border-top: 1px solid rgba(255, 255, 255, 0.15); // Ana bölümle arasına çizgi ekle\n\n        .container {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            flex-wrap: wrap; // Küçük ekranlarda alt alta\n            gap: 15px;\n        }\n\n        .copyright {\n            font-size: 14px;\n            font-weight: 300;\n            color: #fff;\n            margin: 0;\n            flex-grow: 1; // Kalan alanı alsın\n            text-align: left; // Varsayılan sola hizalı kalsın\n             @media (max-width: 767px) {\n                width: 100%; // Mobilde tam genişlik kaplasın\n                text-align: left; // Mobilde de sola hizalı olsun\n                margin-bottom: 40px; // Linklerle arasına boşluk\n                font-size: 16px;\n                font-weight: 400;\n            }\n        }\n\n        .footer-bottom-links {\n            display: flex;\n            gap: 25px; // Masaüstü linkler arası boşluk\n            flex-shrink: 0; // Küçülmesin\n\n            a, .aydinlatma-link-button {\n                font-size: 14px;\n                color: #fff;\n                font-weight: 300;\n                background: none;\n                border: none;\n                padding: 0;\n                cursor: pointer;\n                text-decoration: none;\n                transition: color 0.3s ease;\n\n                &:hover {\n                   color: #09B175;\n                }\n\n                @media (max-width: 767px) {\n                    font-size: 16px;\n                    font-weight: 400;\n                }\n            }\n\n            .aydinlatma-link-button {\n                font-family: inherit; // Font ailesini miras al\n            }\n\n             @media (max-width: 767px) {\n                flex-direction: column; // Mobilde alt alta diz\n                align-items: flex-start; // Sola hizala\n                width: 100%; // Tam genişlik\n                gap: 20px; // Alt alta linkler arası boşluğu 20px yap\n            }\n        }\n\n         @media (max-width: 767px) {\n            .container {\n                flex-direction: column; // Ana container'ı da dikey yap\n                align-items: flex-start; // İçeriği sola hizala\n                text-align: left; // Genel metin hizalamasını sola al\n            }\n            // .copyright { // Yukarıda zaten ayarlandı\n            //     text-align: left;\n            //     margin-bottom: 15px;\n            // }\n            // .footer-bottom-links { // Yukarıda zaten ayarlandı\n            //     flex-direction: column;\n            //     align-items: flex-start;\n            //     gap: 10px;\n            // }\n         }\n    }\n\n    // --- Mobil Footer Stil Güncellemeleri (767px ve altı) ---\n    @media (max-width: 1023px) {\n        .footer-main {\n            padding-bottom: 0; // Ana alt padding'i 0 yapalım, boşlukları bölümler arasına verelim\n\n            .footer-grid {\n                display: flex;\n                flex-direction: column;\n                gap: 0; // Gap sıfır kalsın\n            }\n\n            .footer-column {\n                width: 100%;\n                padding: 0;\n                text-align: left;\n            }\n\n            // Görseldeki Sıralama ve Boşluklar/Borderlar\n            .footer-subscribe { order: 1; padding-bottom: 48px; } // Bülten altı boşluk\n            .footer-servis    {\n                order: 2;\n                padding-top: 20px; // Akordiyon üstüne boşluk\n                border-bottom: 1px solid rgba(255, 255, 255, 0.15); // Alt çizgi\n            }\n            .footer-link      {\n                order: 3;\n                padding-top: 20px; // Akordiyon üstüne boşluk\n                border-bottom: 1px solid rgba(255, 255, 255, 0.15); // Alt çizgi\n            }\n            .footer-about     {\n                order: 4;\n               padding-top: 72px; \n                padding-bottom: 72px; // Footer-main'in altına boşluk ekle\n            }\n\n\n     \n            // 2. & 3. Link Sütunları (Accordion)\n            .footer-links {\n                order: 2; // Veya 3 (Servis ve Link için)\n\n                .footer-title {\n                    font-size: 16px;\n                    font-weight: 500;\n                    position: relative; // ::after için\n                    cursor: pointer;    // Tıklanabilir imleç\n                    padding: 20px 40px 20px 0; // Sağdan ikona yer bırak, alt/üst boşluk\n                    margin: 0; // Başlık margin'i olmasın\n\n                    &::after { // Accordion ikonu (+/-)\n                        content: '+';\n                        font-size: 24px;\n                        font-weight: 300;\n                        color: #fff;\n                        position: absolute;\n                        right: 5px; // İkonu sağa hizala (padding ile boşluk bırakıldı)\n                        top: 50%;\n                        transform: translateY(-50%);\n                        transition: transform 0.3s ease; // İkon dönüşümü için\n                    }\n                }\n\n                ul {\n                    // ---- BAŞLANGIÇTA GİZLEME ----\n                    max-height: 0;\n                    overflow: hidden;\n                    visibility: hidden;\n                    opacity: 0;\n                    margin: 0;\n                    padding: 0 0 0 15px; // Üst/alt/sağ padding 0, soldan hafif içeride\n                    list-style: none;\n                    text-align: left;\n                    transition: max-height 0.4s ease-out, opacity 0.3s ease-in, padding-top 0.4s ease-out, padding-bottom 0.4s ease-out, visibility 0s linear 0.4s;\n\n                    li {\n                        padding: 8px 0; // Sadece dikey padding\n                        a {\n                           font-size: 14px;\n                           display: flex; // İkonu hizalamak için\n                           align-items: center;\n                           img {\n                               margin-right: 8px; // İkon ve metin arası boşluk\n                               width: 12px;\n\n                           }\n                        }\n                    }\n                }\n\n                // ---- AKTİF (AÇIK) DURUM ----\n                &.active {\n                    .footer-title::after {\n                        content: '-'; // İkonu değiştir\n                        transform: translateY(-50%); // Döndürme yok\n                    }\n                    ul {\n                        max-height: 300px; // Yeterli bir yükseklik\n                        visibility: visible;\n                        opacity: 1;\n                        padding-top: 10px; // Açılınca üste boşluk\n                        padding-bottom: 20px; // Açılınca alta boşluk\n                        // Yan padding (padding: 0 0 0 15px;) öncekiyle aynı kalır\n                        transition: max-height 0.4s ease-out, opacity 0.3s ease-in 0.1s, padding-top 0.4s ease-out, padding-bottom 0.4s ease-out, visibility 0s linear 0s;\n                    }\n                }\n            }\n            // Spesifik borderları yukarıda verdik, buradaki genel border kuralları kaldırılabilir.\n            // .footer-servis { border-bottom: ... }\n            // .footer-link { border-top: none; }\n\n\n            // 4. Logo, Açıklama ve Sosyal Medya Bölümü\n            .footer-about {\n                 // border-top: ...; // Kaldıralım, padding-top yeterli\n                 // padding-top: 35px; // Yukarıda ayarlandı\n                 text-align: center; // Ortala\n\n                .footer-description {\n                     text-align: left;\n                }\n            }\n        }\n\n        // En Alt Bölüm (Stilleri aynı kalabilir)\n        .footer-bottom {\n             padding: 72px 0 72px 0;\n             // border-top: 1px solid #fff !important; // Ana stile taşındığı için burada gereksiz\n        }\n    }\n}\n\n// Modal Styles\n.modal {\n    display: none; \n    position: fixed;\n    z-index: 1001; \n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0,0,0,0.6);\n    opacity: 0;\n    transition: opacity 0.3s ease;\n    \n    // Modal açık olduğunda flex yap ve ortala\n    &[style*=\"block\"] {\n        display: flex !important;\n        align-items: center; \n        justify-content: center; \n        opacity: 1;\n    }\n\n    @media (max-width: 767px) { \n        padding-top: 0; \n    }\n}\n\n.modal-content {\n    background-color: #fefefe;\n    padding: 30px;\n    border: 1px solid #888;\n    width: 90%; \n    max-width: 800px; \n    border-radius: 8px; \n    position: relative;\n    box-shadow: 0 10px 30px rgba(0,0,0,0.3);\n    max-height: 80vh; \n    overflow-y: auto;\n    transform: translateY(-50px);\n    transition: transform 0.3s ease;\n    \n    .modal[style*=\"block\"] & {\n        transform: translateY(0);\n    } \n\n    @media (max-width: 767px) { \n        width: 100%;\n        height: 100%;\n        max-width: none;\n        margin: 0;\n        border-radius: 0;\n        border: none; \n        box-shadow: none; \n        display: flex; \n        flex-direction: column;\n        padding: 20px 20px 0 20px; \n        max-height: none; \n        // overflow-y: auto; // Zaten .modal-text-content scroll ediyor mobilde, bu gereksiz olabilir\n    }\n\n    h2 {\n        margin-top: 0;\n        color: #333;\n        border-bottom: 1px solid #eee;\n        padding-bottom: 15px;\n        margin-bottom: 20px;\n\n        @media (max-width: 767px) { \n            padding-right: 45px; \n            flex-shrink: 0; \n            // padding-left: 15px;\n            // padding-top: 15px;\n        }\n    }\n\n    .modal-text-content {\n        // max-height: 60vh; \n        overflow-y: auto; \n\n        color: #555;\n        line-height: 1.6;\n\n        @media (max-width: 767px) {\n            flex-grow: 1; \n            // padding-right: 0; // Scrollbar hala .modal-text-content içinde olduğu için bu kalsın\n            // padding-left: 15px; \n            // padding-bottom: 15px; \n        }\n\n        p {\n            margin-bottom: 15px;\n        }\n\n        ul {\n            margin-bottom: 15px; // Listelerin altına da biraz boşluk ekleyelim\n            padding-left: 20px; // Madde işaretleri için soldan iç boşluk\n            list-style-type: disc; // Madde işaretlerini disk olarak belirle\n        }\n\n        .modal-hukuki-sebep {\n            margin-top: 12px; // Hukuki sebepler için üst boşluk\n        }\n    }\n}\n\n.modal-close-button {\n    color: #aaa;\n    font-size: 28px;\n    font-weight: bold;\n    position: absolute;\n    top: 15px;\n    right: 25px;\n    cursor: pointer; \n\n    &:hover,\n    &:focus {\n        color: black;\n        text-decoration: none;\n    }\n\n    @media (max-width: 767px) { \n        top: 12px; \n        right: 15px; \n        font-size: 26px;\n    }\n}\n\n// Modal Animation\n@keyframes animatetop {\n    from {top: -300px; opacity: 0}\n    to {top: 0; opacity: 1}\n} \n\n// Modal Table Styles\n.modal-table {\n    display: flex;\n    flex-direction: column;\n    gap: 1px; // Row separator gibi davranacak\n    background-color: #ddd; // Row separator rengi\n    border: 1px solid #ddd; // Tablo kenarlığı\n    margin-bottom: 20px;\n}\n\n.modal-table-header,\n.modal-table-row {\n    display: flex;\n    background-color: #f9f9f9; // Satır arka planı\n}\n\n.modal-table-header {\n    background-color: #f0f0f0; // Başlık satırı için farklı arka plan\n    font-weight: bold;\n}\n\n.modal-table-cell {\n    padding: 10px 12px;\n    flex-grow: 1;\n    flex-basis: 0; // Eşit dağılım için temel\n    border-left: 1px solid #ddd; // Hücreler arası dikey çizgi\n\n    &:first-child {\n        border-left: none;\n    }\n\n    p, ul {\n        margin: 0;\n        font-size: 13px; // İçerik font boyutu biraz küçültüldü\n    }\n\n    ul {\n        padding-left: 18px; // Liste başındaki boşluk\n        list-style-type: disc; // Liste işaretçisi\n    }\n}\n\n// Hücre genişlikleri için özel sınıflar (örnek)\n.header-kategori, .cell-kategori {\n    flex-grow: 0.8; // Kategoriler için biraz daha dar\n}\n.header-amac, .cell-amac {\n    flex-grow: 1.5; // Amaçlar için daha geniş\n}\n.header-sebep, .cell-sebep {\n    flex-grow: 1; // Sebepler için standart genişlik\n}\n\n// İkinci tablo için hücre genişlikleri\n.header-aktarilan, .cell-aktarilan {\n    flex-grow: 1.2; // Aktarılan kişi/kuruluş için biraz daha geniş\n}\n.header-aktarim-amac, .cell-aktarim-amac {\n    flex-grow: 1; \n}\n.header-aktarim-sebep, .cell-aktarim-sebep {\n    flex-grow: 1.2; \n}\n\n// Mobil için tablo stil düzenlemesi\n@media (max-width: 767px) {\n    .modal-table {\n        overflow-x: auto; // Yana kaydırmayı etkinleştir\n        display: block; // Flex yerine block, satırların genişliğini koruması için\n    }\n\n    .modal-table-header {\n        display: flex; // Başlık satırını tekrar göster ve flex yapısını koru\n        min-width: 700px; // İçeriğin sığması için minimum genişlik (ayarlanabilir)\n    }\n\n    .modal-table-row {\n        min-width: 700px; // İçeriğin sığması için minimum genişlik (ayarlanabilir)\n        display: flex; // Flex yapısını koru\n    }\n\n    .modal-table-cell {\n        white-space: normal; // Metinlerin normal şekilde kaymasını sağla (nowrap değil)\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
